import { ISkill } from '@shared/interfaces/ISkill';
import { IWorkGroup } from '../../work-group/interfaces/IWorkGroup';

export function extractSkillsFromWorkGroup(workgroup: IWorkGroup) {
  const skills: ISkill[] = [];
  workgroup?.blocks?.forEach((wg) => skills.push(...wg.skills));
  return skills;
}
